/* eslint-disable react/require-default-props */
import React from 'react';
import {
  Card,
  CardAction,
  CardContent,
  CardRow,
  Icon,
  OnPress,
  TitleCard,
  SubTitleCard,
  CardImages,
  Space,
} from './styles';

interface Props {
  img: string;
  id: string;
  icon: string;
  title: string;
  subTitle1?: string;
  subTitle2?: string;
  subTitle3?: string;
  onClick: Function;
  widthImg?: string;
  heightImg?: string;
}

const ItemCard: React.FC<Props> = ({
  img, id, title, subTitle1, onClick, icon, subTitle2, subTitle3, widthImg, heightImg,
}) => (
  <Card key={id}>
    <CardAction>
      <div style={{
        display: 'flex',
        justifyContent: 'center',
      }}
      >
        <CardImages
          style={{ width: widthImg || undefined, height: heightImg || undefined }}
          loading="eager"
          src={[img, 'https://cdn.iconscout.com/icon/free/png-256/round-black-circle-38003.png']}
          alt="Imagem Pole"
        />
      </div>
      <CardContent>
        <CardRow>
          <TitleCard>{title}</TitleCard>
          <OnPress onClick={() => {
            onClick();
          }}
          >
            <Icon height={16} width={18} src={icon} />
          </OnPress>
        </CardRow>
        <Space />
        <Space />
        <SubTitleCard>
          {subTitle1}
        </SubTitleCard>
        <Space />
        <Space />
        <SubTitleCard>
          {subTitle2}
        </SubTitleCard>
        <Space />
        <Space />
        <SubTitleCard>
          {subTitle3}
        </SubTitleCard>
      </CardContent>
    </CardAction>
  </Card>
);
export default ItemCard;
